import React, { useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { Logo } from './Logo';
import { site } from '../data/site';
const links = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'How it works',
  href: '#process'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-sky-100 bg-white/90 backdrop-blur" data-id="element-63" data-mp="2ni7ijhdjjnkw">
      <div className="mx-auto flex h-20 w-full max-w-6xl items-center justify-between px-6" data-id="element-64" data-mp="2rkb7n8t4uqon">
        <Logo data-id="element-65" data-mp="2wj5nq2zpu152" />

        <nav aria-label="Main" className="hidden items-center gap-10 md:flex" data-id="element-66" data-mp="31bysgqv6p9h5">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm text-slate-600 transition-colors hover:text-[#1D4ED8]" data-id="element-67" data-mp="36bl6h2iu6tr0">
              {link.label}
            </a>)}
          <a href={site.phoneHref} className="inline-flex items-center gap-2 rounded-full bg-[#1D4ED8] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#0B2A6B]" data-id="element-68" data-mp="3fcjf5y47zpfx">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="2rkgerd18sb8s" />
            {site.phone}
          </a>
        </nav>

        <button type="button" onClick={() => setOpen(value => !value)} className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-sky-200 text-[#0B2A6B] md:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-70" data-mp="2mohw862lhnga">
          {open ? <X className="h-5 w-5" data-id="element-71" data-mp="35jy885phgcoh" /> : <Menu className="h-5 w-5" data-id="element-72" data-mp="35jg64sg5348n" />}
        </button>
      </div>

      {open && <div id="mobile-nav" className="border-t border-sky-100 bg-white md:hidden" data-id="element-73" data-mp="30m666iv4ja6k">
          <nav aria-label="Mobile" className="mx-auto flex max-w-6xl flex-col gap-1 px-6 py-4" data-id="element-74" data-mp="1y0mkkg4c7yd">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="py-3 text-sm text-slate-700" data-id="element-75" data-mp="3t9adiuhow0li">
                {link.label}
              </a>)}
            <a href={site.phoneHref} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#1D4ED8] px-5 py-3 text-sm font-medium text-white" data-id="element-76" data-mp="1hn8kcs6zpuuy">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="18ls8eg0j1kom" />
              {site.phone}
            </a>
          </nav>
        </div>}
    </header>;
}